module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-inspections panel panel-default"
  }, [_c('div', {
    staticClass: "list-inspections",
    attrs: {
      "data-infinite-scroll": ""
    }
  }, [_c('panel-search', {
    staticClass: "panel-search-light",
    attrs: {
      "placeholder": "Введите ГОС или VIN номер, или название автомобиля для поиска"
    },
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.inspections), function(inspection) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": ("/inspections/" + (inspection.id))
      }
    }, [_vm._v(_vm._s(inspection.brand.name) + " " + _vm._s(inspection.model.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(inspection.state_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(inspection.vin_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date_format")(inspection.completed_at, 'DD.MM.YYYY HH:mm')))])])
  }))]), _vm._v(" "), (_vm.next_page_url) ? _c('button', {
    staticClass: "load-more",
    on: {
      "click": _vm.loadNextPage
    }
  }, [_vm._v("Еще")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Автомобиль")]), _vm._v(" "), _c('th', [_vm._v("Гос. номер")]), _vm._v(" "), _c('th', [_vm._v("VIN номер")]), _vm._v(" "), _c('th', [_vm._v("Заполнено")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-24c9d83a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24c9d83a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ListInspectionsUser.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-24c9d83a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ListInspectionsUser.vue
// module chunks = 0